<div class="toast m-2 mr-4 pointer-events-auto http-debug-toast">
    <div class="row">
        <span class="method">{{ data.method }}</span>
        <span class="url" [title]="data.url">{{ data.url }}</span>
    </div>
    <div class="row meta">
        <span *ngIf="data.waitMs !== null && data.waitMs !== undefined">wait {{ data.waitMs }} ms</span>
        <span *ngIf="loadMs !== null">load {{ loadMs }} ms</span>
        <span *ngIf="data.rawBytes !== null">raw {{ formatBytes(data.rawBytes) }}</span>
        <span *ngIf="data.wireBytes !== null">zip {{ formatBytes(data.wireBytes) }}</span>
        <span class="duration">{{ data.durationMs }} ms</span>
    </div>
    <div class="http-debug-stackbar" *ngIf="data.durationMs && data.durationMs > 0"
        [style.--wait-percent]="waitPercent + '%'">
    </div>
</div>
